import { Box, Typography, Button, Stack } from '@mui/material';
import staticBgImage from '../../../../../../assets/campaigns/trial1.jpg';

const ACCENT_COLOR = '#F8B400';

const Hero = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '90vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: { xs: 2, md: 4 },
        py: { xs: 6, md: 10 },
        overflow: 'hidden',
        backgroundImage: `url(${staticBgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Dark overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))',
          zIndex: 0,
        }}
      />

      {/* Foreground Content */}
      <Box maxWidth={1000} sx={{ position: 'relative', zIndex: 1 }}>
        <Typography
          component="h1"
          fontWeight="bold"
          color="#fff"
          mb={2}
          sx={{
            fontSize: { xs: '3.5rem', md: '7rem' },
            lineHeight: 1.2,
          }}
        >
          Support Dreams, Fuel Possibilities
        </Typography>

        <Typography
          variant="body1"
          color="#f0f0f0"
          mb={4}
          sx={{
            fontSize: { xs: '1rem', md: '1rem' },
            lineHeight: 1.6,
          }}
        >
          Discover and support fundraisers that matter. Join a community of
          changemakers making a real difference. Whether you want to contribute
          as a donor or start your own campaign, we provide the tools and
          platform to make your impact meaningful and visible. Together, we
          create opportunities and transform lives, one fundraiser at a time.
        </Typography>

        {/* Action Buttons */}
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            sx={{
              textTransform: 'none',
              px: 4,
              borderRadius: '8px',
              boxShadow: 0,
              backgroundColor: ACCENT_COLOR,
              '&:hover': { backgroundColor: '#d99900' },
              color: '#000',
            }}
            onClick={() => (window.location.href = '/user/register')}
          >
            Create Account
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{
              px: 4,
              borderRadius: '8px',
              textTransform: 'none',
              boxShadow: 0,
              color: ACCENT_COLOR,
              borderColor: ACCENT_COLOR,
              '&:hover': {
                backgroundColor: ACCENT_COLOR + '22',
                borderColor: ACCENT_COLOR,
                boxShadow: 0,
              },
            }}
            onClick={() => (window.location.href = '/campaigns')}
          >
            Donate
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default Hero;
